import Footer from "./Footer";
import {Image} from "react-bootstrap";
import './StudentsGallery.css';

let DisseminationGallery = () => {
    const verticalImageList = [
        "img_001.jpg",
        "img_011.JPG"    
    ]

    const horizontalImageList = [
        "img_002.jpg",
        "img_003.jpg",
        "img_004.JPG",
        "img_005.JPG",
        "img_006.JPG",
        "img_007.JPG",
        "img_008.JPG",
        "img_010.JPG",
        "img_012.JPG",
        "img_013.JPG",
        "img_014.JPG",
        "img_015.JPG",
        "img_016.JPG",
        "img_017.JPG",
        "img_018.JPG",
        "img_019.JPG",
    ]

    return(
        <div className="content text-center">
            
            <div>
                {horizontalImageList.map(path => <Image className="imageHorizontal m-3" src={require("./img/galeria-upowszechnianie/" + path)} rounded />)}
            </div>

            <div>
                {verticalImageList.map(path => <Image className="imageVertical m-3" src={require("./img/galeria-upowszechnianie/" + path)} rounded />)}
            </div>

        </div>
    )
}

export default DisseminationGallery;